import React, { useState } from "react";
import {
  DescriptionContainer,
  AssetItem,
  AssetItemTitle,
  AssetItemName,
  AssetTechnicalName,
} from "../../../../AssetListScreenStyles";
import { Asset } from "../../../../../../../../interface/Server";
import AssetListItem from "./AssetListItem";
import Collapse from "react-bootstrap/Collapse";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { CarouselWrapper } from "../../../../../../Widget/Carousel";
import { useTranslation } from "react-i18next";
import { getDisplayName } from "./AssetListItem";
import "./animation.css";

interface Props {
  group: Asset; // CustomAssetGroup, //| CustomAsset
  onSelectAsset?: (asset: Asset) => void;
  isMobile?: boolean;
  showArrow?: boolean;
}

// Component that contains parent and dropdown children assets
const AssetGroupListItem: React.FunctionComponent<Props> = (props: Props) => {
  const { group, isMobile } = props;
  const {
    chineseName,
    englishName,
    image,
    images,
    technicalName,
    description,
  } = group;
  const { t, i18n } = useTranslation();
  console.log("AssetGroupListItem");
  const displayName = getDisplayName(i18n.language, englishName, chineseName);
  const useChi = i18n.language === "zhTW" || i18n.language === "cn";
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(!open);
  const filterSponsored = (asset: Asset) => asset.status === "OnShelf";
  const filteredGroupedAssets =
    group && group.childrenAssets
      ? group.childrenAssets.filter(filterSponsored)
      : [];
  // if (!filteredGroupedAssets.length) return null; // all children assets are sponsored do not show parent
  return (
    <>
      <AssetItem>
        <Row style={{ display: "flex", padding: 0, margin: 0 }}>
          {!images || !images.length || images.length <= 1 ? (
            <div
              style={{
                width: isMobile ? "147px" : "220px",
                height: "147px",
                backgroundColor: "#d8d8d8",
                backgroundImage: `url("${
                  (images && images[0]) || image || ""
                }")`,
                backgroundSize: "cover",
              }}
            />
          ) : (
            <div
              style={{ width: isMobile ? "147px" : "220px", height: "147px" }}
            >
              <CarouselWrapper images={group.images} />
            </div>
          )}
          {/* TODO need to show price range of assets? */}
          <Row
            onClick={handleClick}
            style={{ flex: 1, display: "flex", padding: 0, margin: 0 }}
          >
            <Col
              style={{ display: "flex", flexDirection: "column", marginTop: 8 }}
            >
              <DescriptionContainer>
                <AssetItemTitle isChinese={useChi}>
                  {displayName}
                </AssetItemTitle>
                <AssetTechnicalName isChinese={useChi}>{`${t(
                  "scientificName"
                )}: ${technicalName}`}</AssetTechnicalName>
                <AssetItemName isChinese={useChi} truncate>{`${
                  description || ""
                }`}</AssetItemName>
              </DescriptionContainer>
              {!filteredGroupedAssets.length && (
                <div style={{ display: "flex", flex: 1 }}>
                  <AssetItemTitle isChinese={useChi} style={{ color: "black" }}>
                    {t("noItemsAvailable")}
                  </AssetItemTitle>
                </div>
              )}
            </Col>
            {props.showArrow && (
              <img
                id="collapse-arrow"
                className={open ? "opened" : "closed"}
                src={`/donation/assets/icons/down-arrow.svg`}
                style={{ height: 16, width: 16, margin: 8 }}
              />
            )}
          </Row>
        </Row>
      </AssetItem>
      {!!filteredGroupedAssets.length && (
        <Collapse in={open}>
          <>
            {filteredGroupedAssets.map(
              (n: any, i: string | number | undefined) => (
                <Collapse in={open} key={i}>
                  <div>
                    <AssetListItem
                      key={i}
                      asset={n}
                      onSelectAsset={props.onSelectAsset}
                      isMobile={isMobile}
                      displayImage
                      isGroupItem
                    />
                  </div>
                </Collapse>
              )
            )}
          </>
        </Collapse>
      )}
    </>
  );
};

AssetGroupListItem.defaultProps = {
  showArrow: true,
};

export default AssetGroupListItem;
